<template>
  <div>
    <div class="row">
      <div class="col">
        <v-simple-table>
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left">Requested Date</th>
                <th class="text-left">User</th>
                <th class="text-left">Publication</th>
                <th class="text-left">Organization</th>
                <th class="text-left">Start Date</th>
                <th class="text-left">End Date</th>
                <th class="text-left">Status</th>
                <th style="width: 100px"></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in list" :key="item.id">
                <td>{{ item.RequestedDate | formatDate }}</td>
                <td>{{ item.user.firstName }} {{ item.user.lastName }}</td>
                <td>
                    {{ publicationType=1 ? item.publication == null ? "" : item.publication.Title  : "" }} 
                    {{ publicationType=2 ? item.journal == null ? ""  : item.journal.Title : "" }}
                
                </td>
                <td>
                  {{ item.organization == null ? "" : item.organization.Name }}
                </td>
                <td>{{ item.StartDate | formatDate }}</td>
                <td>{{ item.EndDate | formatDate }}</td>
                <td>{{ getLendingStatus(item.status) }} </td>
                <td>
                  <v-icon class="mr-2" @click="onStatus(item)"
                    >mdi-view-grid-outline</v-icon
                  >
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </div>
    </div>
    <div class="row">
      <div class="pr-8 ml-auto">
        <a @click="downloadOnGoing"
          ><v-icon large color="blue" class="px-1"> mdi-cloud-download </v-icon
          >Download</a
        >
      </div>
    </div>
    <div class="row">
      <div class="col">
        <Pagination :paging="paging" v-on:next="onNextPage" />
      </div>
    </div>

    <LendingStatus ref="lendingStatus" />
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
</template>
<script>
import Notification from "@/components/Notification";
import Pagination from "@/components/Pagination";
import LendingStatus from "@/components/LendingStatus";
import * as api from "@/api";

export default {
  name: "LendingOngoing",
  components: {
    Notification,
    Pagination,
    LendingStatus
  },
  created() {
    this.getLending();
  },
  methods: {
    getLending() {
      let that = this;
      that.overlay = true;
      this.list = [];
      new Promise((resolve, reject) => {
        api
          .getByPagin("lending", this.paging)
          .then(response => {
            that.overlay = false;
            resolve(response);
            this.paging.count = response.data.count;
            this.list = response.data.data;
            console.log(this.list);
          })
          .catch(error => {
            that.overlay = false;
            reject(error);
          });
      });
    },
    onSearch() {
      console.log("onSearch" + this.Search);
      this.paging.keyword = this.Search;
      this.getLending();
    },
    onNextPage(page) {
      this.paging.page = page;
      this.paging.keyword = this.Search;
      this.getLending();
    },
    onStatus(item) {
      this.$refs.lendingStatus.open("Lending Status", item.id);
    },
    getLendingStatus(statusId) {
      let status = "";
      switch (statusId) {
        case 1:
          status = "Initializing..";
          break;
        case 2:
          status = "Queued";
          break;
        case 3:
          status = "Availability Checked";
          break;
        case 4:
          status = "Device Registered";
          break;
        case 5:
          status = "No Of Copies Updated";
          break;
        case 6:
          status = "Done";
          break;
        case 7:
          status = "Retrun License";
          break;
        case 8:
          status = "Renew License";
          break;
        case 9:
          status = "Failed";
          break;
        case 10:
          status = "Canceled";
          break;
      }

      return status;
    },
    downloadOnGoing() {
      api.downloadFile("lending/download/ongoing", "ongoing.csv")
    }
  },

  computed: {},
  watch: {},

  data() {
    return {
      list: [],
      Search: "",
      paging: { count: 10, page: 1, size: 10, keyword: "" },
      lendingStatus: [],
      overlay: false
    };
  }
};
</script>



// WEBPACK FOOTER //
// src/components/LendingOngoing.vue